import { useState } from "react";

import { Modal } from "@/modules/common/components";
import EmailCodeStep from "./EmailCodeStep";
import NewPasswordStep from "../NewPasswordStep";

interface FirstAccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPasswordReset: (email: string) => void;
}

const STEP_CONTENT = {
  1: { title: "Primeiro acesso", description: "Informe seu e-mail e o código de verificação que você recebeu." },
  2: { title: "Nova senha", description: "Crie uma nova senha para acessar sua conta." },
} as const;

const FirstAccessModal = ({ open, onOpenChange, onPasswordReset }: FirstAccessModalProps) => {
  const [step, setStep] = useState<1 | 2>(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setStep(1);
      setEmail("");
      setCode("");
    }
    onOpenChange(isOpen);
  };

  const handlePasswordResetSuccess = (resetEmail: string) => {
    handleOpenChange(false);
    onPasswordReset(resetEmail);
  };

  return (
    <Modal open={open} onOpenChange={handleOpenChange} title={STEP_CONTENT[step].title} description={STEP_CONTENT[step].description}>
      {step === 1 && (
        <EmailCodeStep
          onVerified={(verifiedEmail, verifiedCode) => {
            setEmail(verifiedEmail);
            setCode(verifiedCode);
            setStep(2);
          }}
        />
      )}
      {step === 2 && <NewPasswordStep email={email} code={code} submitLabel="Atualizar senha" onSuccess={handlePasswordResetSuccess} />}
    </Modal>
  );
};

export default FirstAccessModal;
